import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";

export const prepareDetailPropertyVirtualTour = (
  data: IPropertyDetailsResponse
): string | null => {
  return data?.realstatetour_url || null;
};

export type IPropertyDetailVirtualTour = string | null;
